import { render, staticRenderFns } from "./UnsavedWarning.vue?vue&type=template&id=1c0b17bc&scoped=true&"
import script from "./UnsavedWarning.vue?vue&type=script&lang=js&"
export * from "./UnsavedWarning.vue?vue&type=script&lang=js&"
import style0 from "./UnsavedWarning.vue?vue&type=style&index=0&id=1c0b17bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0b17bc",
  null
  
)

export default component.exports